// extracted by mini-css-extract-plugin
export var chartWrapper = "expenses-chord-module--chartWrapper--f066b";
export var chordGroup = "expenses-chord-module--chordGroup--b443f";
export var groupText = "expenses-chord-module--groupText--a0329";
export var ribbon = "expenses-chord-module--ribbon--8347d";